"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var extend_1 = __importDefault(require("extend"));
var diff_1 = require("./diff");
var AttributeMap_1 = __importDefault(require("./AttributeMap"));
var Op_1 = __importDefault(require("./Op"));
var toArray_1 = __importDefault(require("lodash/toArray"));
var NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
var Delta = /** @class */ (function () {
    function Delta(ops) {
        var inputOps;
        if (Array.isArray(ops)) {
            inputOps = ops;
        }
        else if (ops != null && Array.isArray(ops.ops)) {
            inputOps = ops.ops;
        }
        else {
            inputOps = [];
        }
        for (var index = 0; index < inputOps.length; index++) {
            var op = inputOps[index];
            if (typeof op.insert === 'object' && Array.isArray(op.insert.ops)) {
                op.insert = new Delta(op.insert.ops);
            }
            else if (typeof op.retain === 'object' && Array.isArray(op.retain.ops)) {
                op.retain = new Delta(op.retain.ops);
            }
        }
        this.ops = inputOps;
    }
    Delta.stringify = function (delta, final) {
        if (final === void 0) { final = true; }
        var res;
        if (final) {
            res = '';
        }
        else {
            res = [];
        }
        for (var index = 0; index < delta.ops.length; index++) {
            var op = delta.ops[index];
            var data = [];
            if (op.insert !== undefined) {
                if (op.insert instanceof Delta) {
                    data.push(Delta.stringify(op.insert, false));
                }
                else {
                    data.push(op.insert);
                }
                if (op.attributes !== undefined) {
                    data.push(op.attributes);
                }
            }
            else if (op.retain !== undefined) {
                if (op.retain instanceof Delta) {
                    data.push(Delta.stringify(op.retain, false));
                }
                else {
                    data.push(op.retain);
                }
                if (op.attributes !== undefined) {
                    data.push(op.attributes);
                }
                data.push(2);
            }
            else if (op.delete !== undefined) {
                data.push(op.delete);
                data.push(3);
            }
            if (final) {
                res += JSON.stringify(data) + '\n';
            }
            else {
                res.push(data);
            }
        }
        return res;
    };
    Delta.parse = function (str) {
        var opStrings = str.split('\n');
        if (opStrings.length > 0) {
            // 先去掉最后的 \n 导致的空字符串
            opStrings.pop();
            if (opStrings.length > 0) {
                var ops = Array(opStrings.length);
                for (var index = 0; index < opStrings.length; index++) {
                    var opJSON = JSON.parse(opStrings[index]);
                    ops[index] = Delta.parseOp(opJSON);
                }
                return new Delta({ ops: ops });
            }
        }
        return null;
    };
    Delta.parseOp = function (opJSON) {
        if (opJSON[1] === undefined) {
            return { insert: Delta.tryParseEmbedDelta(opJSON[0]) };
        }
        else if (typeof opJSON[1] === 'number') {
            if (opJSON[1] === 2) {
                return { retain: Delta.tryParseEmbedDelta(opJSON[0]) };
            }
            else if (opJSON[1] === 3) {
                return { delete: opJSON[0] };
            }
            else {
                throw new Error('unknown op type');
            }
        }
        else if (typeof opJSON[1] === 'object') {
            if (opJSON[2] === undefined) {
                return { insert: Delta.tryParseEmbedDelta(opJSON[0]), attributes: opJSON[1] };
            }
            else if (opJSON[2] === 2) {
                return { retain: Delta.tryParseEmbedDelta(opJSON[0]), attributes: opJSON[1] };
            }
            else {
                throw new Error('unknown op type');
            }
        }
        else {
            throw new Error('wrong data type');
        }
    };
    Delta.tryParseEmbedDelta = function (data) {
        if (typeof data === 'number' || typeof data === 'string') {
            return data;
        }
        else if (Array.isArray(data)) {
            var ops = Array(data.length);
            for (var index = 0; index < data.length; index++) {
                var opJSON = data[index];
                ops[index] = Delta.parseOp(opJSON);
            }
            return new Delta({ ops: ops });
        }
        throw new Error('unknown embed delta format');
    };
    Delta.prototype.insert = function (arg, attributes, key) {
        var newOp = {};
        if (typeof arg === 'string' && arg.length === 0) {
            return this;
        }
        newOp.insert = arg;
        if (attributes != null &&
            typeof attributes === 'object' &&
            Object.keys(attributes).length > 0) {
            newOp.attributes = attributes;
        }
        if (typeof key === 'number') {
            newOp.key = key;
        }
        return this.push(newOp);
    };
    Delta.prototype.delete = function (length) {
        if (length <= 0) {
            return this;
        }
        return this.push({ delete: length });
    };
    Delta.prototype.retain = function (length, attributes) {
        if (typeof length === 'number' && length <= 0) {
            return this;
        }
        var newOp = { retain: length };
        if (attributes != null &&
            typeof attributes === 'object' &&
            Object.keys(attributes).length > 0) {
            newOp.attributes = attributes;
        }
        return this.push(newOp);
    };
    Delta.prototype.push = function (newOp) {
        var index = this.ops.length;
        var lastOp = this.ops[index - 1];
        newOp = extend_1.default(true, {}, newOp);
        if (typeof lastOp === 'object') {
            // 如果最后的操作和新增的操作都是删除，就合并这两个操作
            if (typeof newOp.delete === 'number' &&
                typeof lastOp.delete === 'number') {
                lastOp.delete += newOp.delete;
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === 'number' && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== 'object') {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if (fast_deep_equal_1.default(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === 'string' &&
                    typeof lastOp.insert === 'string') {
                    this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
                    if (typeof newOp.attributes === 'object') {
                        this.ops[index - 1].attributes = newOp.attributes;
                    }
                    return this;
                }
                else if (typeof newOp.insert === 'number' &&
                    typeof lastOp.insert === 'number') {
                    lastOp.insert += newOp.insert;
                    return this;
                }
                else if (typeof newOp.retain === 'number' &&
                    typeof lastOp.retain === 'number') {
                    this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
                    if (typeof newOp.attributes === 'object') {
                        this.ops[index - 1].attributes = newOp.attributes;
                    }
                    return this;
                }
            }
        }
        if (index === this.ops.length) {
            this.ops.push(newOp);
        }
        else {
            this.ops.splice(index, 0, newOp);
        }
        return this;
    };
    Delta.prototype.chop = function () {
        var lastOp = this.ops[this.ops.length - 1];
        if (lastOp && lastOp.retain && typeof lastOp.retain === 'number' && !lastOp.attributes) {
            this.ops.pop();
        }
        return this;
    };
    Delta.prototype.filter = function (predicate) {
        return this.ops.filter(predicate);
    };
    Delta.prototype.forEach = function (predicate) {
        this.ops.forEach(predicate);
    };
    Delta.prototype.map = function (predicate) {
        return this.ops.map(predicate);
    };
    Delta.prototype.partition = function (predicate) {
        var passed = [];
        var failed = [];
        this.forEach(function (op) {
            var target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [passed, failed];
    };
    Delta.prototype.reduce = function (predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    };
    Delta.prototype.changeLength = function () {
        return this.reduce(function (length, elem) {
            if (elem.insert) {
                return length + Op_1.default.length(elem);
            }
            else if (elem.delete) {
                return length - elem.delete;
            }
            return length;
        }, 0);
    };
    Delta.prototype.length = function () {
        return this.reduce(function (length, elem) {
            return length + Op_1.default.length(elem);
        }, 0);
    };
    Delta.prototype.slice = function (start, end) {
        if (start === void 0) { start = 0; }
        if (end === void 0) { end = Infinity; }
        var ops = this.sliceOps(start, end);
        return new Delta(ops);
    };
    Delta.prototype.sliceOps = function (start, end) {
        if (start === void 0) { start = 0; }
        if (end === void 0) { end = Infinity; }
        var ops = [];
        var iter = Op_1.default.iterator(this.ops);
        var index = 0;
        while (index < end && iter.hasNext()) {
            var nextOp = void 0;
            if (index < start) {
                nextOp = iter.next(start - index);
            }
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += Op_1.default.length(nextOp);
        }
        return ops;
    };
    Delta.prototype.compose = function (other) {
        var thisIter = Op_1.default.iterator(this.ops);
        var otherIter = Op_1.default.iterator(other.ops);
        var ops = [];
        var firstOther = otherIter.peek();
        // 先看合入的 delta 的第一条是不是仅仅要修改游标位置
        if (firstOther != null &&
            typeof firstOther.retain === 'number' &&
            firstOther.attributes == null) {
            var firstLeft = firstOther.retain;
            while (thisIter.peekType() === 'insert' &&
                thisIter.peekLength() <= firstLeft) {
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) {
                otherIter.next(firstOther.retain - firstLeft);
            }
        }
        var delta = new Delta(ops);
        while (thisIter.hasNext() || otherIter.hasNext()) {
            if (otherIter.peekType() === 'insert') {
                delta.push(otherIter.next());
            }
            else if (thisIter.peekType() === 'delete') {
                delta.push(thisIter.next());
            }
            else {
                var length_1 = Math.min(thisIter.peekLength(), otherIter.peekLength());
                var thisOp = thisIter.next(length_1);
                var otherOp = otherIter.next(length_1);
                if (typeof otherOp.retain === 'number') {
                    var newOp = {};
                    if (typeof thisOp.retain === 'number') {
                        newOp.retain = length_1;
                    }
                    else {
                        newOp.insert = thisOp.insert;
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    var attributes = AttributeMap_1.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                    if (attributes) {
                        newOp.attributes = attributes;
                    }
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() &&
                        fast_deep_equal_1.default(delta.ops[delta.ops.length - 1], newOp)) {
                        var rest = new Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                    // Other op should be delete, we could be an insert or retain
                    // Insert + delete cancels out
                }
                else if (typeof otherOp.retain === 'object') {
                    // thisOp 分 retain 和 insert 两种情况
                    if (typeof thisOp.retain === 'number') {
                        var newOp = { retain: otherOp.retain };
                        var attributes = AttributeMap_1.default.compose(thisOp.attributes, otherOp.attributes, true);
                        if (attributes) {
                            newOp.attributes = attributes;
                        }
                        delta.push(newOp);
                    }
                    else if (typeof thisOp.retain === 'object') {
                        var retainData = thisOp.retain.compose(otherOp.retain);
                        if (retainData.length() === 0) {
                            retainData = 1;
                        }
                        var newOp = { retain: retainData };
                        var attributes = AttributeMap_1.default.compose(thisOp.attributes, otherOp.attributes, false);
                        if (attributes) {
                            newOp.attributes = attributes;
                        }
                        delta.push(newOp);
                    }
                    else if (typeof thisOp.insert === 'object') {
                        var retainData = thisOp.insert.compose(otherOp.retain);
                        if (retainData.length() === 0) {
                            retainData = 1;
                        }
                        var newOp = { insert: retainData };
                        var attributes = AttributeMap_1.default.compose(thisOp.attributes, otherOp.attributes, false);
                        if (attributes) {
                            newOp.attributes = attributes;
                        }
                        delta.push(newOp);
                    }
                    else if (typeof thisOp.insert === 'number') {
                        var newOp = { insert: otherOp.retain };
                        var attributes = AttributeMap_1.default.compose(thisOp.attributes, otherOp.attributes, true);
                        if (attributes) {
                            newOp.attributes = attributes;
                        }
                        delta.push(newOp);
                    }
                    else {
                        // 如果进入这个分支，说明 thisOp.insert 是 string，这时要和一个 delta 类型 retain Op 进行 compose 操作是非法的
                        console.trace('error compose');
                    }
                }
                else if (typeof otherOp.delete === 'number' &&
                    typeof thisOp.retain === 'number') {
                    delta.push(otherOp);
                }
            }
        }
        return delta.chop();
    };
    Delta.prototype.concat = function (other) {
        var delta = new Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    };
    Delta.prototype.diff = function (other, cursor) {
        if (this.ops === other.ops) {
            return new Delta();
        }
        var sequences = [this, other].map(function (delta) {
            var seq = [];
            delta.forEach(function (op) {
                if (op.insert != null) {
                    if (typeof op.insert === 'string') {
                        var stringSeq = toArray_1.default(op.insert);
                        for (var index = 0; index < stringSeq.length; index++) {
                            seq.push(stringSeq[index]);
                        }
                    }
                    else if (typeof op.insert === 'number') {
                        if (op.insert === 1) {
                            if (typeof op.key === 'number') {
                                seq.push(op.key);
                            }
                            else {
                                seq.push(NULL_CHARACTER);
                            }
                        }
                        else {
                            for (var index = 0; index < op.insert; index++) {
                                seq.push(NULL_CHARACTER);
                            }
                        }
                    }
                    else {
                        // 如果有 key 就用 key 来计算 diff，否则退化成 NULL_CHARACTER
                        if (typeof op.key === 'number') {
                            seq.push(op.key);
                        }
                        else {
                            seq.push(NULL_CHARACTER);
                        }
                    }
                }
                else {
                    var prep = delta === other ? 'on' : 'with';
                    throw new Error('diff() called ' + prep + ' non-document');
                }
            });
            return seq;
        });
        var retDelta = new Delta();
        var diffResult = diff_1.diffSequence(sequences[0], sequences[1], cursor);
        var thisIter = Op_1.default.iterator(this.ops);
        var otherIter = Op_1.default.iterator(other.ops);
        diffResult.forEach(function (component) {
            var length = component[1].reduce(function (totalLength, seqItem) {
                var itemLength = typeof seqItem === 'number' ? 1 : seqItem.length;
                return totalLength + itemLength;
            }, 0);
            while (length > 0) {
                var opLength = 0;
                switch (component[0]) {
                    case diff_1.DiffOp.DIFF_INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case diff_1.DiffOp.DIFF_DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case diff_1.DiffOp.DIFF_EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        // 如果进入这个分支，那么thisOp 和 otherOp 都有可能是 number、delta 中的某一种
                        // 简单排列组合有 4 种情况
                        var thisOp = thisIter.next(opLength);
                        var otherOp = otherIter.next(opLength);
                        if (fast_deep_equal_1.default(thisOp.insert, otherOp.insert)) {
                            // 如果 equal 说明都是 number 或都是 delta 且 delta 内容完全相同
                            retDelta.retain(opLength, AttributeMap_1.default.diff(thisOp.attributes, otherOp.attributes));
                        }
                        else if (typeof thisOp.insert === 'object' &&
                            typeof otherOp.insert === 'object') {
                            // 如果两个都是 delta 且内容不同
                            retDelta.retain(thisOp.insert.diff(otherOp.insert), AttributeMap_1.default.diff(thisOp.attributes, otherOp.attributes));
                        }
                        else {
                            // 如果一个是 number 另一个是 delta
                            retDelta.push(otherOp).delete(opLength);
                        }
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    };
    Delta.prototype.invert = function (base) {
        var inverted = new Delta();
        var baseIndex = 0;
        var _loop_1 = function (index) {
            var op = this_1.ops[index];
            if (op.insert) {
                inverted.delete(Op_1.default.length(op));
            }
            else if (op.retain && op.attributes == null && typeof op.retain === 'number') {
                inverted.retain(op.retain);
                baseIndex += op.retain;
            }
            else if (op.delete || (typeof op.retain === 'number' && op.attributes)) {
                var length_2 = (op.delete || op.retain);
                var slice = base.sliceOps(baseIndex, baseIndex + length_2);
                slice.forEach(function (baseOp) {
                    if (op.delete) {
                        inverted.push(baseOp);
                    }
                    else if (op.retain && op.attributes) {
                        inverted.retain(Op_1.default.length(baseOp), AttributeMap_1.default.invert(op.attributes, baseOp.attributes));
                    }
                });
                baseIndex += length_2;
            }
            else if (typeof op.retain === 'object') {
                var retainData_1 = op.retain;
                var length_3 = 1;
                var slice = base.sliceOps(baseIndex, baseIndex + length_3);
                slice.forEach(function (baseOp) {
                    // 还原 attributes
                    var invertedAttr = op.attributes ? AttributeMap_1.default.invert(op.attributes, baseOp.attributes) : null;
                    // 还原内容，baseOp 的内容是 delta 或 number，这里 baseOp 只能是 insert，如果是 retain 就报错
                    // 这里 baseOp 不可能是 insert string
                    if (typeof baseOp.insert === 'number') {
                        var invertOp = { retain: new Delta().delete(retainData_1.length()) };
                        if (invertedAttr) {
                            invertOp.attributes = invertedAttr;
                        }
                        inverted = inverted.concat(new Delta([invertOp]));
                    }
                    else if (typeof baseOp.insert === 'object') {
                        var invertOp = { retain: retainData_1.invert(baseOp.insert) };
                        if (invertedAttr) {
                            invertOp.attributes = invertedAttr;
                        }
                        inverted = inverted.concat(new Delta([invertOp]));
                    }
                    else {
                        console.trace('can not invert retain', baseOp, op);
                    }
                });
                baseIndex += length_3;
            }
        };
        var this_1 = this;
        for (var index = 0; index < this.ops.length; index++) {
            _loop_1(index);
        }
        return inverted.chop();
    };
    Delta.prototype.transform = function (arg, priority, chop) {
        if (priority === void 0) { priority = false; }
        if (chop === void 0) { chop = true; }
        var _a;
        priority = !!priority;
        if (typeof arg === 'number') {
            return this.transformPosition(arg, priority);
        }
        var other = arg;
        var thisIter = Op_1.default.iterator(this.ops);
        var otherIter = Op_1.default.iterator(other.ops);
        var delta = new Delta();
        while (otherIter.hasNext()) {
            if (thisIter.peekType() === 'insert' &&
                (priority || otherIter.peekType() !== 'insert')) {
                delta.retain(Op_1.default.length(thisIter.next()));
            }
            else if (otherIter.peekType() === 'insert') {
                delta.push(otherIter.next());
            }
            else {
                var length_4 = Math.min(thisIter.peekLength(), otherIter.peekLength());
                var thisOp = thisIter.next(length_4);
                var otherOp = otherIter.next(length_4);
                if (thisOp.delete) {
                    // Our delete either makes their delete redundant or removes their retain
                    continue;
                }
                else if (otherOp.delete) {
                    delta.push(otherOp);
                }
                else {
                    // We retain either their retain or insert
                    var retainAttr = AttributeMap_1.default.transform(thisOp.attributes, otherOp.attributes, priority);
                    if (typeof thisOp.retain === 'number' ||
                        (typeof otherOp.insert === 'number' ||
                            typeof otherOp.retain === 'number')) {
                        var retainData = length_4;
                        if (typeof otherOp.retain === 'object') {
                            retainData = otherOp.retain;
                        }
                        delta.retain(retainData, retainAttr);
                    }
                    else {
                        var otherData = ((_a = otherOp.insert) !== null && _a !== void 0 ? _a : otherOp.retain);
                        delta.retain(thisOp.retain.transform(otherData, priority), retainAttr);
                    }
                }
            }
        }
        if (chop) {
            return delta.chop();
        }
        else {
            return delta;
        }
    };
    Delta.prototype.transformPosition = function (index, priority) {
        if (priority === void 0) { priority = false; }
        priority = !!priority;
        var thisIter = Op_1.default.iterator(this.ops);
        var offset = 0;
        while (thisIter.hasNext() && offset <= index) {
            var length_5 = thisIter.peekLength();
            var nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === 'delete') {
                index -= Math.min(length_5, index - offset);
                continue;
            }
            else if (nextType === 'insert' && (offset < index || !priority)) {
                index += length_5;
            }
            offset += length_5;
        }
        return index;
    };
    Delta.Op = Op_1.default;
    Delta.AttributeMap = AttributeMap_1.default;
    return Delta;
}());
module.exports = Delta;
//# sourceMappingURL=Delta.js.map